import React from "react";
import { Button, Container } from "react-bootstrap";
import "../assets/styles/HeroServiceDetails.css";

const ServiceDetailsHero = () => {

  return (
    <section className="hero-service-details-section reduced-gap">
      <Container className="hero-content">

        <h1 className="hero-subtitle">UX & UI Design &
          Consulting Services</h1>

        {/* Description */}
        <p className="hero-description">
          At Async Vibe, we craft seamless UX/UI design solutions through expert consulting and research, blending aesthetics and functionality. From personas to prototypes, we transform ideas into engaging, optimized user experiences for every industry.
        </p>

        {/* Search Bar */}
        <Button
          style={{
            backgroundColor: 'white',
            color: 'black',
            border: 'none',
            margin: '50px 0 50px 0', // mt-4 mb-5 equivalent
            padding: '0',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '28%',
            borderRadius: '10px',
          }}
        >
          <p style={{
            color: 'black',
            fontWeight: 'bold',
            fontSize: '17px',
            margin: '0',
            padding: '12px 16px',
          }}>
            Discover Simplicity →
          </p>
        </Button>
      </Container>
    </section>
  );
};

export default ServiceDetailsHero;